import Cookies from 'js-cookie';

export const setStorageValue = (key: string, value: string, expires: number = 1) => {
  Cookies.set(key, value, {
    expires,
    secure: true,
    sameSite: 'Strict',
  });
};

export const getStorageValue = (key: string) => {
  const value = Cookies.get(key);
  return value;
};

export const removeStorageValue = (key: string) => {
  Cookies.remove(key);
};
